__turbopack_context__.v({
  "buttonPrimary": "PlasmicGdpr-module__Ji7aPq__buttonPrimary",
  "h1": "PlasmicGdpr-module__Ji7aPq__h1",
  "h3__a2Nc2": "PlasmicGdpr-module__Ji7aPq__h3__a2Nc2",
  "h3__bbOy5": "PlasmicGdpr-module__Ji7aPq__h3__bbOy5",
  "h3__cW0N": "PlasmicGdpr-module__Ji7aPq__h3__cW0N",
  "h3__m7Oz4": "PlasmicGdpr-module__Ji7aPq__h3__m7Oz4",
  "h3__mnoYj": "PlasmicGdpr-module__Ji7aPq__h3__mnoYj",
  "h3__nhwEq": "PlasmicGdpr-module__Ji7aPq__h3__nhwEq",
  "h3__tkmrN": "PlasmicGdpr-module__Ji7aPq__h3__tkmrN",
  "h3__w2MeX": "PlasmicGdpr-module__Ji7aPq__h3__w2MeX",
  "root": "PlasmicGdpr-module__Ji7aPq__root",
  "svg__lJsy": "PlasmicGdpr-module__Ji7aPq__svg__lJsy",
  "svg__wpfA": "PlasmicGdpr-module__Ji7aPq__svg__wpfA",
  "text___7Nu60": "PlasmicGdpr-module__Ji7aPq__text___7Nu60",
  "text___7SUa": "PlasmicGdpr-module__Ji7aPq__text___7SUa",
  "text___8RrEh": "PlasmicGdpr-module__Ji7aPq__text___8RrEh",
  "text__agbn": "PlasmicGdpr-module__Ji7aPq__text__agbn",
  "text__dylEv": "PlasmicGdpr-module__Ji7aPq__text__dylEv",
  "text__hhSaT": "PlasmicGdpr-module__Ji7aPq__text__hhSaT",
  "text__hiBva": "PlasmicGdpr-module__Ji7aPq__text__hiBva",
  "text__hwufw": "PlasmicGdpr-module__Ji7aPq__text__hwufw",
  "text__miOhi": "PlasmicGdpr-module__Ji7aPq__text__miOhi",
  "text__nyZtu": "PlasmicGdpr-module__Ji7aPq__text__nyZtu",
  "text__pntAj": "PlasmicGdpr-module__Ji7aPq__text__pntAj",
  "text__wa1Td": "PlasmicGdpr-module__Ji7aPq__text__wa1Td",
  "text__xeTW": "PlasmicGdpr-module__Ji7aPq__text__xeTW",
  "text__yruBn": "PlasmicGdpr-module__Ji7aPq__text__yruBn",
  "text__znlbU": "PlasmicGdpr-module__Ji7aPq__text__znlbU",
  "ul__gyhPs": "PlasmicGdpr-module__Ji7aPq__ul__gyhPs",
  "ul__uufJt": "PlasmicGdpr-module__Ji7aPq__ul__uufJt",
  "ul__xiv6G": "PlasmicGdpr-module__Ji7aPq__ul__xiv6G",
  "ul__zyRys": "PlasmicGdpr-module__Ji7aPq__ul__zyRys",
});
